import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Router } from '@angular/router';
import { StudentNavCourse } from '@edtech-ui/core/models/nav-courses-and-quizzes/get-all-courses';
import { StudentNavClassroom } from '@edtech-ui/core/models/nav-courses-and-quizzes/get-all-nav-student-classroom';
import { CourseManagementService } from '@edtech-ui/core/services/course-management/course-management.service';
import { StudentService } from '@edtech-ui/core/services/student-management/student.service';
import { TeacherServicesService } from '@edtech-ui/core/services/teacher-services.service';
import { ToastrService } from 'ngx-toastr';
import { PaginatorModule } from 'primeng/paginator';
import { catchError, debounceTime, finalize, of, Subject, Subscription, tap } from 'rxjs';

@Component({
	selector: 'app-student-all-course',
	standalone: true,
	imports: [CommonModule, FormsModule, PaginatorModule,MatProgressSpinnerModule],
	templateUrl: './student-all-course.component.html',
	styleUrls: ['../../../teacher/courses/courses.component.scss']
})
export class StudentAllCourseComponent implements OnInit, OnDestroy {

	studentCourses: StudentNavCourse[] = [];
	allStudentCourse: StudentNavCourse[] = [];
	classrooms: StudentNavClassroom[] = [];
	isLoading = false;
	pageNo: number = 1;
	pageSize: number = 10;
	totalPages: number = 0;
	classroomId: number = 0;
	classroomFilter: number = 0;
	Teacherfilter: string = '';
	searchCourseByName: string = '';
	subscription = new Subscription();
	searchInput$ = new Subject<string>();

	constructor(
		private _teacherService: TeacherServicesService,
		private _courseService: CourseManagementService,
		private _toastr: ToastrService,
		private router: Router,
		private _studentService: StudentService,

	) { }


	ngOnInit(): void {
		this.getAllStudentCourses();
		this.getAllStudentClassrooms();

		this.subscription.add(
			this.searchInput$.pipe(debounceTime(300)).subscribe(value => {
				this.searchCourseByName = value;
				this.pageNo = 1;
				this.getAllStudentCourses();
			})
		);
	}

	getAllStudentCourses() {
		this.isLoading = true;
		const params = {
			page: this.pageNo,
			page_size: this.pageSize,
			search: this.searchCourseByName,
			classroom_filter: this.classroomFilter
		};
		this.subscription.add(
			this._teacherService.getAllStudentCourses(params).pipe(
				tap(response => {
					if (response.Success) {
						this.studentCourses = response.Data.courses;
						this.allStudentCourse = response.Data.courses;
						this.totalPages = response.Data.total_count;
					} else {
						this.studentCourses = [];
						this.allStudentCourse = [];
					}
				}),
				catchError(() => {
					this._toastr.error('Something went wrong while fetching courses');
					return of(null);
				}),
				finalize(() => {
					this.isLoading = false;
				}),
			).subscribe()
		)
	}


	goToCoursePage(course: StudentNavCourse) {
		const courseId = course.course_id;
		const classroom = this.classrooms.find(c => c.name === course.classroom);
		const classroomId = classroom?.id;

		if (!courseId || !classroomId) {
			this._toastr.error('Invalid course or classroom details', 'Navigation Error');
			return;
		}

		this.subscription.add(
		this._courseService.getCoursesByCourseId(courseId).subscribe({
			next: (res) => {
				if (!res?.Success || !res.Data) {
					this._toastr.error('Failed to load course details', 'Error');
					return;
				}
				const courseDetails = res.Data;
				if (courseDetails.is_ai) {
					this.router.navigate(['/teacher-dashboard/ai-course-result', this.classroomId, courseId]);
				} else {
					this.router.navigate(['/teacher-dashboard', this.classroomId, 'manual-course-creation', 'course-preview'
					], { queryParams: { courseId } });
				}
			},
			error: () => {
				this._toastr.error('Server error while loading course');
			},
		})
	);
	}

	getAllStudentClassrooms() {
		this.subscription.add(
			this._studentService.getAllNavStudentClassrooms().pipe(
				tap(response => {
					if (response.Success) {
						this.classrooms = response.Data.classrooms;
					}
				}),
				catchError(() => {
					this._toastr.error('Something went wrong file fetching the classrooms');
					return of(null);
				})
			).subscribe()
		)
	}

	onFilterChange() {
		this.pageNo = 1;
		this.getAllStudentCourses();
	}

	onPageChange(event: any) {
		this.pageNo = event.page + 1;
		this.pageSize = event.rows;
		this.getAllStudentCourses();
	}

	onSearchChange(search: string) {
		this.searchInput$.next(search);
	}

	clearClassroom() {
		this.classroomFilter = 0;
		this.pageNo = 1;
		this.getAllStudentCourses();
	}

	getSelectedClassroomName(): string {
		const classroom = this.classrooms.find(c => c.id === +this.classroomFilter);
		return classroom ? classroom.name : '';
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}
}